import React, { useState } from 'react';
//colors #0F151A #F6F5EE #FD6101  #36A6C9]
const NavBar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <nav className="bg-gradient-to-r from-[#0F151A] to-[#102C44] text-white p-4 shadow-md">
      <div className="container mx-auto flex justify-between items-center">
        {/* Logo and Brand Name */}
        <div className="flex items-center space-x-2">
          <img 
            src="../../nav_logo.png" 
            alt="Veltrah Logo" 
            className="h-15 w-40" // Adjust size as needed
          />
          <div className="text-2xl font-bold"></div>
        </div>
        
        {/* Mobile Menu Toggle */}
        <div className="md:hidden">
          <button 
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="text-white focus:outline-none"
          >
            {isMenuOpen ? '✕' : '☰'}
          </button>
        </div>

        {/* Navigation Links */}
        <ul className={`
          md:flex space-x-6 
          ${isMenuOpen ? 'block' : 'hidden'}
          absolute md:relative 
          top-16 md:top-0 
          left-0 md:left-auto 
          w-full md:w-auto 
          bg-[#0F151A] md:bg-transparent 
          p-4 md:p-0
        `}>
          <li className="hover:text-[#365DC9] transition duration-300 text-l"><a href="#home">Home</a></li>
          <li className="hover:text-[#365DC9] transition duration-300 text-l"><a href="#services">Products</a></li>
          <li className="hover:text-[#365DC9] transition duration-300 text-l"><a href="#about">About</a></li>
          <li className="hover:text-[#36C9A2] transition duration-300">
            <a 
                href="mailto:info@veltrah.com" 
                className="bg-[#FD6101] text-white px-4 py-2 rounded-full hover:bg-opacity-90"
            >
                Contact
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default NavBar;